const mediaQuery = window.matchMedia("(min-width: 920px)");

const elements = {
  nav: document.querySelector(".js-nav"),
  navToggle: document.querySelector(".js-nav-toggle"),
  header: document.querySelector(".js-header"),
};

function toggleMenu() {
  if (elements.navToggle.getAttribute("aria-expanded") === "false") {
    elements.navToggle.setAttribute("aria-expanded", true);
  } else {
    elements.navToggle.setAttribute("aria-expanded", false);
  }

  elements.nav.classList.toggle("is-visible");
  elements.navToggle.classList.toggle("is-open");
}

function resetMobileMenu() {
  elements.nav.classList.remove("is-visible");
  elements.navToggle.setAttribute("aria-expanded", false);
  elements.navToggle.classList.remove("is-open");
}

function focusTrap() {
  const focusableEls = elements.header.querySelectorAll(
    "a[href]:not([disabled])"
  );
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];

  const KEYCODE_TAB = 9;

  focusableEls.forEach((el) => el.addEventListener("click", resetMobileMenu));

  [firstFocusableEl, lastFocusableEl].forEach((el) => {
    {
      el.addEventListener("keydown", function (e) {
        if (
          e.key === "Tab" ||
          (e.keyCode === KEYCODE_TAB && !mediaQuery.matches)
        ) {
          if (e.shiftKey) {
            /* shift + tab */ if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus();
              e.preventDefault();
            }
          } /* tab */ else {
            if (
              document.activeElement === lastFocusableEl &&
              !mediaQuery.matches
            ) {
              firstFocusableEl.focus();
              e.preventDefault();
            }
          }
        }
      });
    }
  });
}

function init() {
  if (!elements.header) {
    return;
  }

  elements.navToggle.addEventListener("click", toggleMenu);
  window.addEventListener("resize", resetMobileMenu);
  focusTrap();
}

export default init;
